import { useBrand } from '@/shared/brand/useBrand';
import { AppShell } from '@/shell/AppShell';
import { ClientShell } from '@/shell/ClientShell';
import { PwaStatus } from '@/shared/pwa/PwaStatus';

/**
 * One SPA, two route trees. The brand comes from the hostname — there is no
 * redirect between domains (docs/ARCHITECTURE.md §1).
 *
 * `document.title` is set to the brand name by the inline script in
 * index.html and then owned by each screen, so it stays correct on every
 * route change without a parent effect racing the children.
 */
export default function App() {
  const brand = useBrand();
  return (
    <>
      {brand.id === 'procalendar' ? <ClientShell /> : <AppShell />}
      <PwaStatus />
    </>
  );
}
